import React, { useState } from 'react';
import { isSuperAdmin } from 'utils/jwtRole';
import CreateTenantLanding from './CreateTenantLanding';
import TenantFormTabs from './TenantFormTabs';

// Multi-tenancy platform console — the super admin's Tenants page (routed at
// /tenants inside SuperAdminLayout). This is the Create Tenant flow:
//   • a drafts landing ("Continue creating" + "Provision a new tenant"), then
//   • the tabbed form once a draft is opened.
//
// Switch Tenant is now its own side-nav entry (/switch-tenant → SelectTenant),
// so there are no outer tabs here.
function TenantConsole() {
  // Which draft (if any) is open. null = landing view.
  const [openDraftId, setOpenDraftId] = useState(null);

  // UI convenience gate only — the draft/provision APIs enforce the real
  // role-99 check server-side.
  if (!isSuperAdmin()) {
    return (
      <div className="p-5">
        <div className="p-5 bg-white borderStyle">
          Only the super admin can access the tenant console.
        </div>
      </div>
    );
  }

  // Tenant created — return to the landing so the promoted draft drops out of
  // the (draft-only) list and the super admin can start another.
  const handleProvisioned = () => setOpenDraftId(null);

  return openDraftId ? (
    <TenantFormTabs draftId={openDraftId} onProvisioned={handleProvisioned} />
  ) : (
    <CreateTenantLanding onOpenDraft={setOpenDraftId} />
  );
}

export default TenantConsole;
